import { MdArrowRightAlt } from "react-icons/md";
import "./Parameters.css";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { GiSandsOfTime } from "react-icons/gi";

const Parameters = ({ desc_ts,  stockStrength, theme }: any) => {  
  const { pathname } = useLocation();
  let pathType: any = pathname.split("/").pop()?.toLowerCase();

  let model_open_date: any =
    desc_ts[0]["open_date"] === undefined
      ? desc_ts[0]["dt_date"]
      : desc_ts[0]["open_date"];

  let openDateIsTodayOrNot: any =
    model_open_date === moment(new Date()).format("YYYY-MM-DD");
  let productCodeKey: any =
    openDateIsTodayOrNot === true ? "s_code" : "identifier";

//     useEffect(()=>{
//   console.log("props parmas",desc_ts);

// //pass
//     },[desc_ts])

  return (
    <>
    {
      desc_ts?.length > 0 ?
      <>
      <h6 style={{ fontFamily: "monospace" }}>
        {desc_ts[0]?.s_code === undefined
          ? " "
          : desc_ts[0]?.s_code?.slice(1, 3) === "ES" ||
            desc_ts[0]?.s_code?.slice(0, 3) === "QEB"
          ? `${desc_ts[0]?.s_symbol}`
          : `${desc_ts[0]?.model_type}`}
        <span className="detailsSymbol" style={{ color: "grey" }}>
          {" "}
          {desc_ts[0]?.s_code}
        </span>
      </h6>

      <h6 className="mb-3 trade_time">
        {" "}
        <GiSandsOfTime />
        {desc_ts[0]?.s_code?.slice(1, 3) === "ES" || desc_ts[0]?.s_code?.slice(0, 3) === "QEB" ? 
        moment(desc_ts[0]?.dt_date).format("DD MMM YYYY") +
            " " + (desc_ts[0]?.tsl_arr[desc_ts[0]?.tsl_arr?.length - 1]?.time?.split(" "))[1]
          : desc_ts[0]?.model_type === "N50 OpS-LFT"
          ? desc_ts[0].tsl_arr[desc_ts[0]?.tsl_arr?.length - 1]?.time?.split(" ")[1]
          : desc_ts[0]?.tsl_arr[desc_ts[0]?.tsl_arr?.length - 1]?.time}
        <MdArrowRightAlt />
        {desc_ts[0]?.s_status !== "Open"
          ? desc_ts[0]?.s_code?.slice(1, 3) === "ES" ||
            desc_ts[0]?.s_code?.slice(0, 3) === "QEB"
            ? moment(desc_ts[0]?.dt_close_date).format("DD MMM YYYY") +
              " " +
              desc_ts[0]?.dt_exit_time
            : desc_ts[0]?.dt_exit_time
          : "Trade is open"}
      </h6>

      {desc_ts[0]?.s_code != undefined &&
        desc_ts[0]?.s_code?.slice(1, 3) === "ES" &&
        stockStrength.length > 0 && (
          <h6 style={{ fontFamily: "monospace" }}>
            <span className="font-semibold">Strength </span>
            {stockStrength}
          </h6>
        )}

      {desc_ts[0]?.s_code?.slice(1, 3) === "ES" &&
      desc_ts[0]?.j_dividend_arr?.length > 0 ? (
        <p className="font-semibold">Dividend</p>
      ) : (
        ""
      )}
      {desc_ts[0]?.j_dividend_arr?.length > 0
        ? desc_ts[0]?.j_dividend_arr?.map((item: any,index:number) => {
            return (
              
              <section key={index}>
                <p
                  className="font-semibold"
                  style={{
                    color: `${theme === "light" ? "#615b5b" : "white"}`,
                  }}
                >
                  {item?.date} <MdArrowRightAlt />{" "}
                  <span
                    style={{ color: item?.value > 0 ? "green" : "orangered" }}
                  >
                    {item?.value}
                  </span>
                </p>
              </section>
            );
          })
        : ""}

      {desc_ts[0]?.s_code?.slice(2, 3) !== "F" &&
      desc_ts[0]?.s_code?.slice(1, 3) !== "ES" &&
      desc_ts[0]?.s_code?.slice(0, 3) !== "QEB" ? (
        <p>
          <span className="font-semibold">
            {" "}
            {desc_ts[0]?.s_option_type ?? desc_ts[0]?.option_type} Strike{" "} {/*bug fixed*/}
          </span>{" "}
          {desc_ts[0]?.n_strike_price ?? desc_ts[0]?.strike_price} {/*bug fixed*/}
        </p>
      ) : (
        ""
      )}
      {desc_ts[0]?.s_code?.slice(2, 3) !== "F" &&
      desc_ts[0]?.s_code?.slice(1, 3) !== "ES" &&
      desc_ts[0]?.s_code?.slice(0, 3) !== "QEB" ? (
        <p>
          {" "}
          <span className="font-semibold">Expiry Date </span>{" "}
          {moment(desc_ts[0]?.dt_expiry_date).format("DD MMM YYYY")}
        </p>
      ) : (
        ""
      )}

      <p className="font-semibold" style={{ marginTop: "0.2rem" }}>
        Target & Stoploss
      </p>
      {desc_ts[0]?.tsl_arr?.map((ts_value: any, idx: any) => {
        return (
          <section className="sectionGapParameter" key={idx}>
            {ts_value?.target && ts_value?.stoploss ? (
              <span>
                <span>
                  {" "}
                  <span className="font-semibold">
                    {pathType === "live"
                      ? ts_value?.time
                      : desc_ts[0]?.dt_open_time},
                    {" "}
                  </span>{" "}
                  <span style={{ fontFamily: "monospace" }}>Target</span>
                </span>{" "}
                <MdArrowRightAlt />{" "}
                {String(ts_value[productCodeKey])?.slice(0, -1) === "AIONIFKKI"
                  ? ts_value?.target.toFixed(2)
                  : ts_value?.target.toFixed(2)}
                , <span style={{ fontFamily: "monospace" }}>Stoploss</span>{" "}
                <MdArrowRightAlt />{" "}
                {String(ts_value[productCodeKey])?.slice(0, -1) === "AIONIFKKI"
                  ? ts_value?.stoploss.toFixed(2)
                  : ts_value?.stoploss.toFixed(2)}
              </span>
            ) : ts_value?.target ? (
              <span>
                {" "}
                <span className="font-semibold">
                  {pathType === "live"
                    ? ts_value?.time
                    : desc_ts[0]?.dt_open_time}
                  ,{" "}
                </span>
                <span style={{ fontFamily: "monospace" }}>Target</span>{" "}
                <MdArrowRightAlt />{" "}
                {String(ts_value[productCodeKey])?.slice(0, -1) === "AIONIFKKI"
                  ? ts_value?.target.toFixed(2)
                  : ts_value?.target.toFixed(2)}
              </span>
            ) : ts_value?.stoploss ? (
              <span>
                <span className="font-semibold">
                  {pathType === "live"
                    ? ts_value?.time
                    : desc_ts[0]?.dt_open_time}
                  ,{" "}
                </span>
                <span style={{ fontFamily: "monospace" }}> Stoploss</span>{" "}
                <MdArrowRightAlt />{" "}
                {String(ts_value[productCodeKey])?.slice(0, -1) === "AIONIFKKI"
                  ? ts_value?.stoploss.toFixed(2)
                  : ts_value?.stoploss.toFixed(2)}
              </span>
            ) : (
              ""
            )}
          </section>
        );
      })}
      </>
      :
      <h1>Nothing to show</h1>
    }
      
    </>
  );
};

export default Parameters;
